export default "__VITE_ASSET__dVAVTGLz__"